import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createGameSlice, GameState } from './slices/gameSlice';

type StoreState = GameState;

export const useStore = create<StoreState>()(
  devtools(
    (...args) => ({
      ...createGameSlice(...args),
    }),
    { name: 'BusinessGameStore' }
  )
);

// Selectors
export const useTeam = () => useStore((state) => ({
  teamName: state.teamName,
  teamId: state.teamId,
}));

export const useSession = () => useStore((state) => state.sessionCode);

export const useGameState = () => useStore((state) => ({
  currentRound: state.currentRound,
  maxRounds: state.maxRounds,
  pointsPerRound: state.pointsPerRound,
  selectedCriterias: state.selectedCriterias,
  totalPoints: state.getTotalPoints(),
  remainingPoints: state.getRemainingPoints(),
}));
